<template>
  <div class="index-box">
    <div class="text-jieshao" v-if="constitutionList != ''">
      <div class="contentTxt">
        <div class="firstLevel">{{ profiles }}</div>
        <div v-for="(segment, index) in constitutionList" :key="index">
          {{ segment }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      profiles: "",
      constitutionList: [],
    };
  },
  created() {
    this.getConstitution();
  },
  methods: {
    async getConstitution() {
      const result = await this.$http.get("/amData/getAmDataArticle");
      console.log("获取学校章程", result.data);
      this.profiles = result.data[0].title;
      const content = result.data[0].content.split("\n");
      // 重新组合分段，包含关键字
      const constitutionList = [];
      for (let i = 0; i < content.length; i++) {
        constitutionList.push(content[i]);
      }
      this.constitutionList = constitutionList;
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .text-jieshao {
    display: flex;
    flex-direction: column;
    width: 95vw;
    border-radius: 10px;
    border: 1px solid #e2e2e2;
    background: #fff;
    font-size: 1rem;
    font-weight: 500;
    line-height: 25px; //行间距
    color: #747474;
    text-indent: 4ch; //首行缩进
    text-align: justify; //两端对齐
    margin-top: 10px;
    .contentTxt {
      padding: 0.5rem 1rem 1rem 1rem;
      line-height: 25px;
    }
    .firstLevel {
      font-size: 1.2rem;
      font-weight: bold;
      color: #000000;
      margin-bottom: 10px;
      margin-top: 10px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/Constitution.vue